import React from 'react'

function MandatoryMark() {
    return (
        <span className="w3-text-red p-bold-600">
            *
        </span>
    )
}

export default MandatoryMark
